import React, { useEffect } from "react";
import { ConfirmContainer } from "./style";
import Button from "../button";

/**
 * Confirm pop up.
 * @param {object} content
 * content={
 *    type: 'success || warning || danger || info',
 *    icon: 'ICON_NAME',
 *    title: 'modal title',
 *    message: 'modal message',
 *    comment: 'a comment that show in bottom of message',
 *    acceptButtonText: 'BUTTON_TEXT',
 *    rejectButtonText: 'BUTTON_TEXT'
 * onChange true , false
 *  }
 * @param {function} acceptHandler
 * @param {function} rejectHandler
 * @param {function} close
 * @param {boolean} show
 */
export const Confirm = props => {
  useEffect(() => {
    if (props.show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [props.show]);
  return (
    <ConfirmContainer type={props.content.type} show={props.show}>
      <div
        className="overlay"
        onClick={(props.loading || !props.close) ? () => false : () => props.close()}
      />
      <div className="confirm-box">
        <div className="confirm-header">
          {props.content.icon && <i
              className={`confirm-icon icon ${props.content.icon ||
              "icon mapsa-notification"}`}
          />
          }
          {props.content.imageIcon && <img src={props.content.imageIcon} alt=""/> }
        </div>
        <div className="confirm-body">
          <div className="title">{props.content.title}</div>
          <div className="message">{props.content.message}</div>
          <small>{props.content.comment}</small>
        </div>
        <div className="confirm-footer">
          {props.content.acceptButtonText && props.acceptHandler !== undefined && (
            <Button
              type="button"
              btn={"outline"}
              borderless={"borderLess"}
              onClick={e => {
                e.preventDefault();
                props.acceptHandler();
              }}
              loading={props.loading}
            >
              {props.content.acceptButtonText}
            </Button>
          )}
          {props.content.rejectButtonText && props.rejectHandler !== undefined && (
            <Button
              disabled={props.loading ? 1 : 0}
              type="button"
              btn={"outline"}
              borderless={"borderLess"}
              onClick={e => {
                e.preventDefault();
                props.rejectHandler();
              }}
            >
              {props.content.rejectButtonText}
            </Button>
          )}
        </div>
      </div>
    </ConfirmContainer>
  );
};
